var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C6.1075 0.5 0.5 6.1075 0.5 13C0.5 19.8925 6.1075 25.5 13 25.5C19.8925 25.5 25.5 19.8925 25.5 13C25.5 6.1075 19.8925 0.5 13 0.5ZM13 5.625C13.8975 5.625 14.625 6.35254 14.625 7.25C14.625 8.14746 13.8975 8.875 13 8.875C12.1025 8.875 11.375 8.14746 11.375 7.25C11.375 6.35254 12.1025 5.625 13 5.625ZM16 19.75H10.5C9.94771 19.75 9.5 19.3023 9.5 18.75C9.5 18.1977 9.94771 17.75 10.5 17.75H12.25V12.25H11.25C10.6977 12.25 10.25 11.8023 10.25 11.25C10.25 10.6977 10.6977 10.25 11.25 10.25H13.25C13.8023 10.25 14.25 10.6977 14.25 11.25V17.75H16C16.5523 17.75 17 18.1977 17 18.75C17 19.3023 16.5523 19.75 16 19.75Z",
    fill: "#0061FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert_info.9be9028d004c87661d7b9f97d3753569.svg";
export { ForwardRef as ReactComponent };